export const fromMoneyToNumber = ({ units, nanos = 0 }) => {
  const _nanos = parseInt(nanos, 10) * 10 ** -9;
  const _units = parseInt(units, 10);
  return _nanos + _units;
};

export default { fromMoneyToNumber };
